import type { useFortress } from "@foundation/fortress";

export type FortressState = ReturnType<typeof useFortress>;

const FORTRESS_STATES = {
    allow: "allow",
    block: "block",
    pending: "pending",
};

// wrapper interface to hide Fortress implementation details
export interface FortressResult {
    isAllowed: boolean;
    isBlocked: boolean;
    isLoading: boolean;
    isUsingOverlay: boolean | undefined;
}

export const getFortressState = ({
    paywallStatus,
    paywallDetails,
}: FortressState): FortressResult => {
    const isAllowed = paywallStatus === FORTRESS_STATES.allow;
    const isBlocked = paywallStatus === FORTRESS_STATES.block;
    const isLoading = paywallStatus === FORTRESS_STATES.pending;

    return {
        isAllowed,
        isBlocked,
        isLoading,
        isUsingOverlay: paywallDetails.isUsingOverlay,
    };
};
